// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ec-b";
export var colorBlue = "_ec-8";
export var colorDot = "_ec-0";
export var colorDotLarge = "_ec-2";
export var colorDotSmall = "_ec-1";
export var colorGreen = "_ec-7";
export var colorGrey = "_ec-3";
export var colorOrange = "_ec-5";
export var colorPink = "_ec-a";
export var colorPurple = "_ec-9";
export var colorRed = "_ec-4";
export var colorYellow = "_ec-6";